export enum Route {
    CustomNutritionStatements = "custom-nutrition-statements"
}

export const getCustomNutritionStatementById = (customNutritionStatementId: number) => `${Route.CustomNutritionStatements}/${customNutritionStatementId}`;